import { HttpClient } from "@angular/common/http";
import { Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { environment } from "../../environments/environment";
import { Helpers } from "../helpers";
import { TranslateConfigService } from "../theme/home/translateConfig.service";
import { appService } from "../_services/app.service";
declare var moment: any;
// declare var $: any;
import * as $ from "jquery";
const LNG_KEY = "SELECTED_LANGUAGE";

@Component({
  selector: "app-print-formats",
  templateUrl: "./print-formats.component.html",
  styleUrls: ["./print-formats.component.scss"],
})
export class PrintFormatsComponent implements OnInit {
  codDodArray: any[] = [];
  totalAmountCodDodArray: any;
  totalAmountInvoiceDetails: any;
  sumInvoiceDetailsAmountAfterCod: any;
  //added by maaria on 22-09-2023
  GSTForKSH: any;
  PANForKSH: any;
  //end
  selectedLang: string;
  hostUrl = environment.apiUrl;
  //hostUrl = 'https://infinity.ifreightbox.net/'
  isInternational: boolean = false;
  mgPath: any;
  SelectedComapnyName: any;
  SelectedCompanyAdd: any;
  SelectedCompanyCIN: any;
  SelectedCompantGSTIN: any;
  SelectedCompanyLogo: any;
  SelectedCompanyPAN: any;
  SelectedCompanyLUT: any;
  SelectedCompantEmail: any;
  SelectedCompanyPhone: any;
  SelectedCompanyWebsite: any;
  SelectedCompanyOther: any;
  TenantUsers: any;
  CompanyIdForCookie: any;
  CompanyId: any;
  imgPath: any;
  InvoiceId: string = "";
  PrintData: any = [];
  PrintType: any = "";
  InvoiceType: any = "";
  SelectedCompanyLogoImg: any;
  TaxApplicableFlag: boolean = false;
  SumOfAmount: any = 0;
  //added by vithujan 07-03-2023
  PrintGateInPass: any = {};
  static that: PrintFormatsComponent;
  BookingId: any;
  ConsignmentsData: any;
  ConsignmentNoteId: any;
  ConsignmentNote_2 = [1, 2, 3];
  CompId: any;
  From: any;
  SalesFlag: boolean = false;
  //added by vithujan 05-05-2023
  PrintQuoteData: any = [];
  InvoiceData: any = [];
  QuoteCompanyData: any;
  QuoteUserData: any;
  UserId: any;
  //end
  //added by vithujan 03-06-2023
  isISAUrl: any =
    environment.apiUrl == "https://isa.ifreightbox.net/" ? true : false;
  //added by vithujan 22-06-2023
  SelectedCompanyMSME: any;
  svg: any;
  isNCCUrl: any =
    environment.apiUrl == "https://ncc.ifreightbox.net/" ? true : false;

  constructor(
    private service: TranslateConfigService,
    private translate: TranslateService,
    private toastr: ToastrService,
    private _appService: appService,
    private _activatedRoute: ActivatedRoute,
    private http: HttpClient
  ) {
    PrintFormatsComponent.that = this;

    if (this.hostUrl == "https://nol.ifreightbox.net/") {
      let language = "en";
      let value = localStorage.getItem(LNG_KEY);
      if (value === "" || value === null || value === undefined) {
        this.translate.setDefaultLang(language);
        this.selectedLang = language;
      } else {
        this.service.setLanguage("en");
        this.selectedLang = "en";
      }
      let val = localStorage.getItem(LNG_KEY);
    } else {
      let language = "en";
      let value = localStorage.getItem(LNG_KEY);
      if (value === "" || value === null || value === undefined) {
        this.translate.setDefaultLang(language);
        this.selectedLang = language;
      } else {
        this.service.setLanguage("en");
        this.selectedLang = "en";
      }
      let val = localStorage.getItem(LNG_KEY);
    }
  }

  ngOnInit() {
    this.GetSalesFlag();
    this.LoadTaxApplicable();
    this.SalesFlag = JSON.parse(localStorage.getItem("SalesFlag"));
  }

  LoadTaxApplicable() {
    var apiUrl =
      environment.apiUrl + "api/Common/GetSystemSettingByName/IsTaxApplicable";

    this.http.get(apiUrl).subscribe(
      (response) => {
        if (response == "1") {
          this.TaxApplicableFlag = true;
        } else {
          this.TaxApplicableFlag = false;
        }
      },
      (err) => {
        this.toastr.error(
          "Error occurred while fetching Status data !",
          "error"
        );
      }
    );
  }

  PrintInvoice() {
    this.GetUserCompany(this.InvoiceId);

    if (this.isISAUrl == true) {
      for (var i = 0; i < this.PrintData.length; i++) {
        this.PrintData[i].InvoiceDetailsA = [];
        this.PrintData[i].InvoiceDetailsB = [];
        this.PrintData[i].Charges = [];
      }
    }

    if (this.InvoiceType == "PrintInvoiceKSHSummary") {
      this.GetTaxIdByType(this.PrintData[0].ChargeType);
    }
    if (
      this.InvoiceType != "PrintTripSheet" &&
      this.InvoiceType != "PrintLorryReceipt4" &&
      this.InvoiceType != "PrintLorryReceipt5" &&
      this.InvoiceType != "PrintQuote"
    ) {
      this.PrintData[0].InvoiceDetails.forEach((element) => {
        this.SumOfAmount = this.SumOfAmount + element.kshIAF_Amount;
      });
    }
  }

  //added by maaria on 22-09-2023 by bhavesh sir for ksh print invoice
  GetTaxIdByType(Type: any) {
    this._appService.GetTaxIdByType("Sales", "GetTaxIdByType", Type).subscribe(
      (response) => {
        if (response) {
          this.GSTForKSH = response[0].TaxId;
          this.PANForKSH = this.GSTForKSH.toString().substring(2, 12);
        }
      },
      (err) => {
        this.toastr.error("An error occured while deleting data !", "error");
      }
    );
  }
  //end

  GetSalesFlag() {
    var apiUrl =
      environment.apiUrl + "api/OrdersByVehicle/GetTaxServiceSetting";

    this.http.get(apiUrl).subscribe(
      (res) => {
        const value = JSON.stringify(res);
        this.isInternational = this.getBoolean(value);
      },
      (err) => {
        console.log(err);
      }
    ); // ends here
  }

  getBoolean(value) {
    switch (value) {
      case true:
      case "true":
      case 1:
      case "1":
      case "on":
      case "yes":
        return true;
      default:
        return false;
    }
  }

  GetUserCompany(id: string) {
    var type = "";
    var singleInvoiceId: any = "";

    if (this.InvoiceType == "PrintTripSheet") {
      singleInvoiceId = this.BookingId;
      type = "BookingId";
    } else if (this.InvoiceType == "PrintLorryReceipt4") {
      singleInvoiceId = this.CompId;
      type = "CompanyId";
    } else if (this.InvoiceType == "PrintLorryReceipt5") {
      singleInvoiceId = this.CompId;
      type = "CompanyId";
    } else if (this.InvoiceType == "PrintQuote") {
      singleInvoiceId = this.CompId;
      type = "CompanyId";
    } else {
      if (id != null) {
        singleInvoiceId = id.split(",")[0];
      }
      type = "InvoiceId";
    }
    var apiUrl =
      environment.apiUrl +
      "api/Company/GetUserCompanyDataByInvoice?id=" +
      singleInvoiceId +
      "&param1=" +
      type;

    this.http.get(apiUrl).subscribe(
      (response: any) => {
        this.TenantUsers = response.data; //FOR DROPDOWN

        this.TenantUsers.forEach((element) => {
          this.CompanyIdForCookie = element;

          this.CompanyId = this.CompanyIdForCookie.Id;
          this.SelectedComapnyName =
            this.CompanyIdForCookie.SelectedComapnyName;
          this.SelectedCompanyAdd = this.CompanyIdForCookie.SelectedCompanyAdd;
          this.SelectedCompanyCIN = this.CompanyIdForCookie.SelectedCompanyCIN;
          this.SelectedCompantGSTIN =
            this.CompanyIdForCookie.SelectedCompantGSTIN;
          this.SelectedCompanyLogo = this.CompanyIdForCookie.CompanyLogoPath;
          this.SelectedCompanyPAN = this.CompanyIdForCookie.SelectedCompanyPAN;
          this.SelectedCompanyLUT = this.CompanyIdForCookie.SelectedCompanyLUT;
          this.SelectedCompantEmail =
            this.CompanyIdForCookie.SelectedComapnyEmail;
          this.SelectedCompanyPhone =
            this.CompanyIdForCookie.SelectedCompanyPhone;
          this.SelectedCompanyWebsite = this.CompanyIdForCookie.Website;
          this.SelectedCompanyOther =
            this.CompanyIdForCookie.SelectedCompanyMSME;
          console.log(this.SelectedCompanyOther, "SelectedCompanyOther");
          //$(".LoginCompanyLogo").attr("src", environment.apiUrl + this.SelectedCompanyLogo);
          this.imgPath = environment.apiUrl + this.SelectedCompanyLogo;
          this.SelectedCompanyLogoImg =
            environment.apiUrl + this.SelectedCompanyLogo;
          //added by vithujan 22-06-2023
          this.SelectedCompanyMSME =
            this.CompanyIdForCookie.SelectedCompanyMSME;
        });
        setTimeout(() => {
          if (this.InvoiceType == "Summary") {
            this.PrintSummary();
          } else if (this.InvoiceType == "PrintSummary_NCCTransportCharges") {
            this.PrintSummary_NCCTransportCharges();
          } else if (
            this.InvoiceType == "PrintSummary_NCCWithoutTransportCharges"
          ) {
            this.PrintSummary_NCCWithoutTransportCharges();
          } else if (this.InvoiceType == "PrintSummary_NCCBookingWise") {
            this.PrintSummary_NCCBookingWise();
          } else if (this.InvoiceType == "Summary_FixedKM") {
            this.PrintSummary_FixedKM();
          } else if (this.InvoiceType == "Detail") {
            this.PrintDetail();
          } else if (this.InvoiceType == "Detail1") {
            this.PrintDetail1();
          } else if (this.InvoiceType == "PDF_EInvoice") {
            setTimeout(() => {
              this.Print_PDF_EInvoice();
            }, 500);
          } else if (this.InvoiceType == "Detail1OnLatterPad") {
            this.PrintDetail1OnLatterPad();
          } else if (this.InvoiceType == "OnLatterPad_EInvoice") {
            setTimeout(() => {
              this.PrintOnLatterPad_EInvoice();
            }, 500);
          } else if (this.InvoiceType == "Detail_KM_MT") {
            this.PrintDetail_KM_MT();
          } else if (this.InvoiceType == "PrintInvoiceKSH") {
            this.PrintInvoiceKSH();
          } else if (this.InvoiceType == "PrintInvoiceKSHSummary") {
            this.PrintInvoiceKSHSummary();
          } else if (
            this.InvoiceType == "PrintInvoiceAnnexureformatGeneralKSH"
          ) {
            this.PrintInvoiceAnnexureformatGeneral();
          } else if (this.InvoiceType == "PrintTripSheet") {
            this.PrintTripSheet(this.BookingId);
          } else if (this.InvoiceType == "PrintLorryReceipt4") {
            this.PrintLorryReceipt4(this.ConsignmentNoteId);
          } else if (this.InvoiceType == "PrintLorryReceipt5") {
            this.PrintLorryReceipt4(this.ConsignmentNoteId);
          } else if (this.InvoiceType == "NCCTermsCondition") {
            this.PrintNCCTermsCondition();
          } else if (this.InvoiceType == "PrintQuote") {
            this.PrintQuote();
          } else if (this.InvoiceType == "PrintInvoiceInfinity") {
            this.PrintInvoiceInfinity();
          } else {
            this.PrintUBInvoice();
          }
        }, 1000);
      },
      (err) => {
        console.log(err);
        console.log("Error occured");
      }
    );
  }

  PrintSummary() {
    if (this.isISAUrl == true) {
      for (var i = 0; i < this.PrintData.length; i++) {
        this.PrintData[i].InvoiceDetails.sort(function (a, b) {
          var ChargedGSTA = a.ChargedGST ? a.ChargedGST : "";
          var ChargedGSTB = b.ChargedGST ? b.ChargedGST : "";
          return ChargedGSTA.localeCompare(ChargedGSTB);
        });

        this.PrintData[i].InvoiceDetailsA = [];
        this.PrintData[i].InvoiceDetailsB = [];
        this.PrintData[i].Charges = [];

        this.PrintData[i].InvoiceDetails.forEach((element) => {
          if (element.ChargedGST == "NA") {
            var isDone: any = false;
            this.PrintData[i].InvoiceDetailsB.forEach((elementD) => {
              if (
                element.ChargeType == elementD.ChargeType &&
                element.SACCODE == elementD.SACCODE &&
                element.ChargedGST == elementD.ChargedGST &&
                element.ToCity == elementD.ToCity &&
                element.Unit == elementD.Unit &&
                element.Rate == elementD.Rate
              ) {
                isDone = true;
                elementD.QuantityA = parseFloat(
                  (elementD.QuantityA + element.Quantity).toFixed(2)
                );
                elementD.DiscountA = parseFloat(
                  (elementD.DiscountA + element.Discount).toFixed(2)
                );
                elementD.AmountA = parseFloat(
                  (elementD.AmountA + element.Amount).toFixed(2)
                );
              }
            });
            if (isDone == false) {
              var objA: any = {};
              objA = element;
              objA.QuantityA = element.Quantity;
              objA.RateA = element.Rate;
              objA.DiscountA = element.Discount;
              objA.AmountA = element.Amount;
              this.PrintData[i].InvoiceDetailsB.push(objA);
            }
          } else {
            var isDone: any = false;
            this.PrintData[i].InvoiceDetailsA.forEach((elementD) => {
              if (
                element.ChargeType == elementD.ChargeType &&
                element.SACCODE == elementD.SACCODE &&
                element.ChargedGST == elementD.ChargedGST &&
                element.ToCity == elementD.ToCity &&
                element.Unit == elementD.Unit &&
                element.Rate == elementD.Rate
              ) {
                isDone = true;
                elementD.QuantityA = parseFloat(
                  (elementD.QuantityA + element.Quantity).toFixed(2)
                );
                elementD.DiscountA = parseFloat(
                  (elementD.DiscountA + element.Discount).toFixed(2)
                );
                elementD.AmountA = parseFloat(
                  (elementD.AmountA + element.Amount).toFixed(2)
                );
              }
            });
            if (isDone == false) {
              var objA: any = {};
              objA = element;
              objA.QuantityA = element.Quantity;
              objA.RateA = element.Rate;
              objA.DiscountA = element.Discount;
              objA.AmountA = element.Amount;
              this.PrintData[i].InvoiceDetailsA.push(objA);
            }
          }

          var data = this.PrintData[i].Charges.filter(
            (x) => x.Name === element.ChargeType
          );
          if (data.length <= 0) {
            var obj: any = {};
            obj.Name = element.ChargeType;
            obj.Amount = 0;
            this.PrintData[i].Charges.push(obj);
          }
        });

        this.PrintData[i].Charges.forEach((element) => {
          var data = this.PrintData[i].InvoiceDetails.filter(
            (x) => x.ChargeType === element.Name
          );
          if (data.length > 0) {
            var totalAmount = 0;
            for (let index = 0; index < data.length; index++) {
              totalAmount = totalAmount + data[index].Amount;
            }
            element.Amount = totalAmount;
          }
        });
      }
    }

    setTimeout(() => {
      var divElements = document.getElementById("PrintSummary");
      var $iframe: any = $("<iframe id='frame'>").appendTo("body");
      var printDiv = divElements.innerHTML;
      var win = $iframe[0].contentWindow || $iframe[0];

      $(win.document).ready(function () {
        setTimeout(() => {
          win.window.print();
          setTimeout(() => {
            $iframe.remove();
          }, 500);
        });
      });

      $iframe.contents().find("body").html(printDiv);
      $("#PrintInvoice").val("");
      Helpers.setLoading(false);
    }, 1000);
  }

  PrintSummary_NCCTransportCharges() {
    console.log("print", this.PrintData);
    setTimeout(() => {
      var divElements = document.getElementById(
        "PrintSummary_NCCTransportCharges"
      );
      var $iframe: any = $("<iframe id='frame'>").appendTo("body");
      var printDiv = divElements.innerHTML;
      var win = $iframe[0].contentWindow || $iframe[0];
      $(win.document).ready(function () {
        setTimeout(() => {
          win.window.print();
          setTimeout(() => {
            $iframe.remove();
          }, 500);
        });
      });
      $iframe.contents().find("body").html(printDiv);
      $("#PrintInvoice").val("");
      Helpers.setLoading(false);
    }, 500);
  }

  PrintSummary_NCCWithoutTransportCharges() {
    setTimeout(() => {
      var divElements = document.getElementById(
        "PrintSummary_NCCWithoutTransportCharges"
      );
      var $iframe: any = $("<iframe id='frame'>").appendTo("body");
      var printDiv = divElements.innerHTML;
      var win = $iframe[0].contentWindow || $iframe[0];
      $(win.document).ready(function () {
        setTimeout(() => {
          win.window.print();
          setTimeout(() => {
            $iframe.remove();
          }, 500);
        });
      });
      $iframe.contents().find("body").html(printDiv);
      $("#PrintInvoice").val("");
      Helpers.setLoading(false);
    }, 500);
  }

  PrintSummary_NCCBookingWise() {
    var VarInvoiceDetails: any = [];
    var obj: any = {};
    this.PrintData.forEach((element) => {
      element.TotalQty = 0;
      VarInvoiceDetails = [];
      VarInvoiceDetails = element.InvoiceDetails;
      element.InvoiceDetails = [];
      // var distinctList = VarInvoiceDetails.map(obj => obj.LRNumber).filter((value, index, self) => self.indexOf(value) === index);
      var distinctList = VarInvoiceDetails.map((obj) => ({
        ConsignmentNo: obj.ConsignmentNo,
        PaidWeight: obj.PaidWeight,
      })).filter(
        (value, index, self) =>
          index ===
          self.findIndex((obj) => obj.ConsignmentNo === value.ConsignmentNo)
      );
      var sum_of_gross_wt = 0.0;
      distinctList.forEach((ele) => {
        sum_of_gross_wt += ele.PaidWeight;
      });

      VarInvoiceDetails.forEach((element1) => {
        obj = {};
        obj.FromCity = element1.FromCity;
        obj.ToCity = element1.ToCity;
        obj.PaidWeight = element1.PaidWeight;
        obj.Quantity = element1.Quantity;
        obj.Rate = element1.Rate;
        obj.Discount = element1.Discount;
        obj.Amount = element1.Amount;
        obj.VehicleNo = element.VehicleNo;
        obj.FromToCity = element1.FromToCity;
        //added by vithujan 18-10-2023 - Siddarth
        obj.Route1 = element1.Route1;
        obj.SACCODE = element1.SACCODE;
        obj.LRNumber = element1.LRNumber;

        VarInvoiceDetails.sort(function (a, b) {
          var VehicleNoA = a.LRNumber ? a.LRNumber : "";
          var VehicleNoB = b.LRNumber ? b.LRNumber : "";
          // var VehicleNoA = a.VehicleNo ? a.VehicleNo : '';
          // var VehicleNoB = b.VehicleNo ? b.VehicleNo : '';

          return VehicleNoA.localeCompare(VehicleNoB);
        });

        obj.ChargedGST = element1.ChargedGST;
        let indexToUpdate = element.InvoiceDetails.findIndex(
          (item) =>
            item.FromCity == element1.FromCity && item.ToCity == element1.ToCity
        );
        let indexToUpdatelr = element.InvoiceDetails.findIndex(
          (item) => item.LRNumber == element1.LRNumber
        );
        if (indexToUpdate != -1) {
          element.InvoiceDetails[indexToUpdate].PaidWeight = parseFloat(
            sum_of_gross_wt.toFixed(2)
          );
          // if (element1.LRNumber == VarInvoiceDetails[indexToUpdate].LRNumber) {
          //   element.InvoiceDetails[indexToUpdate].PaidWeight = element1.PaidWeight.toFixed(2);
          //   //element1.PaidWeight.toFixed(2);
          // } else {
          //   // if()
          //   element.InvoiceDetails[indexToUpdate].PaidWeight = parseFloat(element.InvoiceDetails[indexToUpdate].PaidWeight) + parseFloat(element1.PaidWeight);
          //   //element.InvoiceDetails[indexToUpdate].PaidWeight = element1.PaidWeight.toFixed(2);
          // }

          //element.InvoiceDetails[indexToUpdate].PaidWeight = parseFloat((element.InvoiceDetails[indexToUpdate].PaidWeight + element1.PaidWeight).toFixed(2)); works
          // }

          // element.InvoiceDetails[indexToUpdate].PaidWeight = parseFloat((element.InvoiceDetails[indexToUpdate].PaidWeight + element1.PaidWeight).toFixed(2));
          // element1.PaidWeight.toFixed(2);

          // element.InvoiceDetails[indexToUpdate].Quantity = parseFloat((element.InvoiceDetails[indexToUpdate].Quantity + element1.Quantity).toFixed(2));
          element.InvoiceDetails[indexToUpdate].Quantity = 1;
          element.InvoiceDetails[indexToUpdate].Rate = parseFloat(
            (
              element.InvoiceDetails[indexToUpdate].Rate + element1.Rate
            ).toFixed(2)
          );
          element.InvoiceDetails[indexToUpdate].Discount = parseFloat(
            (
              element.InvoiceDetails[indexToUpdate].Discount + element1.Discount
            ).toFixed(2)
          );
          element.InvoiceDetails[indexToUpdate].Amount = parseFloat(
            (
              element.InvoiceDetails[indexToUpdate].Amount + element1.Amount
            ).toFixed(2)
          );
        } else {
          element.InvoiceDetails.push(obj);
        }
      });
      element.InvoiceDetails.forEach((element2) => {
        element.TotalQty = parseFloat(
          (element.TotalQty + element2.Quantity).toFixed(2)
        );
      });

      console.log("dd", VarInvoiceDetails);
    });
    setTimeout(() => {
      console.log("print", this.PrintData);
      var divElements = document.getElementById("PrintSummary_NCCBookingWise");
      var $iframe: any = $("<iframe id='frame'>").appendTo("body");
      var printDiv = divElements.innerHTML;
      var win = $iframe[0].contentWindow || $iframe[0];
      $(win.document).ready(function () {
        setTimeout(() => {
          win.window.print();
          setTimeout(() => {
            $iframe.remove();
          }, 500);
        });
      });
      $iframe.contents().find("body").html(printDiv);
      $("#PrintInvoice").val("");
      Helpers.setLoading(false);
    }, 500);
  }

  PrintSummary_FixedKM() {
    setTimeout(() => {
      var divElements = document.getElementById("PrintSummary_FixedKM");
      var $iframe: any = $("<iframe id='frame'>").appendTo("body");
      var printDiv = divElements.innerHTML;
      var win = $iframe[0].contentWindow || $iframe[0];

      $(win.document).ready(function () {
        setTimeout(() => {
          win.window.print();
          setTimeout(() => {
            $iframe.remove();
          }, 500);
        });
      });

      Helpers.setLoading(false);

      $iframe.contents().find("body").html(printDiv);

      $("#PrintInvoice").val("");
    }, 1000);
  }

  PrintDetail() {
    if (this.isISAUrl == true) {
      for (var i = 0; i < this.PrintData.length; i++) {
        this.PrintData[i].InvoiceDetails.sort(function (a, b) {
          var ChargedGSTA = a.ChargedGST ? a.ChargedGST : "";
          var ChargedGSTB = b.ChargedGST ? b.ChargedGST : "";
          return ChargedGSTA.localeCompare(ChargedGSTB);
        });

        this.PrintData[i].InvoiceDetailsA = [];
        this.PrintData[i].InvoiceDetailsB = [];
        this.PrintData[i].Charges = [];

        this.PrintData[i].InvoiceDetails.forEach((element) => {
          if (element.ChargedGST == "NA") {
            this.PrintData[i].InvoiceDetailsB.push(element);
          } else {
            this.PrintData[i].InvoiceDetailsA.push(element);
          }

          var data = this.PrintData[i].Charges.filter(
            (x) => x.Name === element.ChargeCode
          );
          if (data.length <= 0) {
            var obj: any = {};
            obj.Name = element.ChargeCode;
            obj.Amount = 0;
            this.PrintData[i].Charges.push(obj);
          }
        });

        this.PrintData[i].Charges.forEach((element) => {
          var data = this.PrintData[i].InvoiceDetails.filter(
            (x) => x.ChargeCode === element.Name
          );
          if (data.length > 0) {
            var totalAmount = 0;
            for (let index = 0; index < data.length; index++) {
              totalAmount = totalAmount + data[index].Amount;
            }
            element.Amount = totalAmount;
          }
        });
      }
    }

    setTimeout(() => {
      var divElements = document.getElementById("PrintDetail");

      var $iframe: any = $("<iframe id='frame1'>").appendTo("body");

      var printDiv = divElements.innerHTML;

      var win = $iframe[0].contentWindow || $iframe[0];

      $(win.document).ready(function () {
        setTimeout(() => {
          win.window.print();

          setTimeout(() => {
            $iframe.remove();
          }, 500);
        });
      });

      $iframe.contents().find("body").html(printDiv);

      $("#PrintInvoice").val("");

      Helpers.setLoading(false);
    }, 1000);
  }

  PrintDetail1() {
    console.log("PrintData", this.PrintData);
    console.log("SalesFlag", this.SalesFlag);
    setTimeout(() => {
      var divElements = document.getElementById("PrintDetail1");
      var $iframe: any = $("<iframe id='frame1'>").appendTo("body");
      var printDiv =
        "<style type='text/css' media='print'>@page { size: A4;  margin: 0.635cm; }</style><html ><head><title></title></head><body>" +
        divElements.innerHTML +
        "</body></html>";
      // var printDiv = "<style type='text/css' media='print'>@page {display:block; width:100%;  margin: 0mm; }</style><html><head><title></title></head><body>" + divElements.innerHTML + "</body></html>";
      var win = $iframe[0].contentWindow || $iframe[0];
      console.log("printDiv", printDiv);
      $(win.document).ready(function () {
        setTimeout(() => {
          win.window.print();
          setTimeout(() => {
            $iframe.remove();
          }, 500);
        });
      });
      $iframe.contents().find("body").html(printDiv);
      $("#PrintInvoice").val("");
      Helpers.setLoading(false);
    }, 1000);
  }

  Print_PDF_EInvoice() {
    setTimeout(() => {
      var divElements = document.getElementById("Print_PDF_EInvoice");
      var $iframe: any = $("<iframe id='frame1'>").appendTo("body");
      var printDiv =
        "<style type='text/css' media='print'>body {zoom: 90%;} @page { size: A4;  margin: 0.635cm; }</style><html ><head><title></title></head><body>" +
        divElements.innerHTML +
        "</body></html>";
      // var printDiv = "<style type='text/css' media='print'>@page {display:block; width:100%;  margin: 0mm; }</style><html><head><title></title></head><body>" + divElements.innerHTML + "</body></html>";
      var win = $iframe[0].contentWindow || $iframe[0];
      console.log("printDiv", printDiv);
      $(win.document).ready(function () {
        setTimeout(() => {
          win.window.print();
          setTimeout(() => {
            $iframe.remove();
          }, 500);
        });
      });
      $iframe.contents().find("body").html(printDiv);
      $("#PrintInvoice").val("");
      Helpers.setLoading(false);
    }, 1000);
  }

  PrintDetail1OnLatterPad() {
    setTimeout(() => {
      var divElements = document.getElementById("PrintDetail1_latterPad");

      var $iframe: any = $("<iframe id='frame1'>").appendTo("body");

      // <style type='text/css' media='print'>@page { size: auto;  margin: 0mm; }</style>

      var printDiv =
        "<style type='text/css' media='print'>@page { size: A4;  margin: 0mm; }</style><html><head><title></title></head><body>" +
        divElements.innerHTML +
        "</body></html>";

      var win = $iframe[0].contentWindow || $iframe[0];

      $(win.document).ready(function () {
        setTimeout(() => {
          win.window.print();

          setTimeout(() => {
            $iframe.remove();
          }, 500);
        });
      });

      $iframe.contents().find("body").html(printDiv);

      $("#PrintInvoice").val("");

      Helpers.setLoading(false);
    }, 1000);
  }

  PrintOnLatterPad_EInvoice() {
    setTimeout(() => {
      var divElements = document.getElementById("Print_latterPad_EInvoice");
      var $iframe: any = $("<iframe id='frame1'>").appendTo("body");
      // <style type='text/css' media='print'>@page { size: auto;  margin: 0mm; }</style>
      var printDiv =
        "<style type='text/css' media='print'>body {zoom: 90%;} @page { size: A4;  margin: 0mm; }</style><html><head><title></title></head><body>" +
        divElements.innerHTML +
        "</body></html>";
      var win = $iframe[0].contentWindow || $iframe[0];
      $(win.document).ready(function () {
        setTimeout(() => {
          win.window.print();
          setTimeout(() => {
            $iframe.remove();
          }, 500);
        });
      });
      $iframe.contents().find("body").html(printDiv);
      $("#PrintInvoice").val("");
      Helpers.setLoading(false);
    }, 1000);
  }

  PrintDetail_KM_MT() {
    setTimeout(() => {
      var divElements = document.getElementById("PrintDetail_KM_MT");

      var $iframe: any = $("<iframe id='frame1'>").appendTo("body");

      var printDiv = divElements.innerHTML;

      var win = $iframe[0].contentWindow || $iframe[0];

      $(win.document).ready(function () {
        setTimeout(() => {
          win.window.print();

          setTimeout(() => {
            $iframe.remove();
          }, 500);
        });
      });

      $iframe.contents().find("body").html(printDiv);

      $("#PrintInvoice").val("");

      Helpers.setLoading(false);
    }, 1000);
  }

  PrintUBInvoice() {
    setTimeout(() => {
      var divElements = document.getElementById("PrintUBInvoice");

      var $iframe: any = $("<iframe id='frame1'>").appendTo("body");

      var printDiv = divElements.innerHTML;

      var win = $iframe[0].contentWindow || $iframe[0];

      $(win.document).ready(function () {
        setTimeout(() => {
          win.window.print();

          setTimeout(() => {
            $iframe.remove();
          }, 500);
        });
      });

      $iframe.contents().find("body").html(printDiv);

      $("#PrintInvoice").val("");

      Helpers.setLoading(false);
    }, 1000);
  }

  PrintInvoiceKSH() {
    setTimeout(() => {
      var divElements = document.getElementById("PrintSummaryKSH");
      var $iframe: any = $("<iframe id='frame'>").appendTo("body");
      var printDiv = divElements.innerHTML;
      var win = $iframe[0].contentWindow || $iframe[0];
      $(win.document).ready(function () {
        setTimeout(() => {
          win.window.print();
          setTimeout(() => {
            $iframe.remove();
          }, 500);
        });
      });
      $iframe.contents().find("body").html(printDiv);
      $("#PrintInvoice").val("");
      Helpers.setLoading(false);
    }, 1000);
  }

  PrintInvoiceKSHSummary() {
    setTimeout(() => {
      var divElements = document.getElementById("PrintSummaryKSH_summary");
      var $iframe: any = $("<iframe id='frame'>").appendTo("body");
      var printDiv = divElements.innerHTML;
      var win = $iframe[0].contentWindow || $iframe[0];
      $(win.document).ready(function () {
        setTimeout(() => {
          win.window.print();
          setTimeout(() => {
            $iframe.remove();
          }, 500);
        });
      });
      $iframe.contents().find("body").html(printDiv);
      $("#PrintInvoice").val("");
      Helpers.setLoading(false);
    }, 1000);
  }

  PrintInvoiceAnnexureformatGeneral() {
    setTimeout(() => {
      var divElements = document.getElementById(
        "PrintInvoiceAnnexureformatGeneralKSH"
      );
      var $iframe: any = $("<iframe id='frame'>").appendTo("body");
      // var printDiv = divElements.innerHTML;
      var printDiv =
        "<style type='text/css' media='print'>@page { size: A4;  margin: 0mm; }</style><html><head><title></title></head><body>" +
        divElements.innerHTML +
        "</body></html>";
      var win = $iframe[0].contentWindow || $iframe[0];
      $(win.document).ready(function () {
        setTimeout(() => {
          win.window.print();
          setTimeout(() => {
            $iframe.remove();
          }, 500);
        });
      });
      $iframe.contents().find("body").html(printDiv);
      $("#PrintInvoice").val("");
      Helpers.setLoading(false);
    }, 1000);
  }

  PrintTripSheet(BookingId) {
    Helpers.setLoading(true);
    PrintFormatsComponent.that._appService
      .GetById("Booking", "GetTripSheet", BookingId)
      .subscribe(
        (response) => {
          PrintFormatsComponent.that.PrintGateInPass = {};
          PrintFormatsComponent.that.PrintGateInPass = response.Table[0];
          PrintFormatsComponent.that.PrintGateInPass.ConsignmentDetailList =
            response.Table1;

          PrintFormatsComponent.that.PrintGateInPass.TotalWeight = 0;
          PrintFormatsComponent.that.PrintGateInPass.TotalQty = 0;

          PrintFormatsComponent.that.PrintGateInPass.ConsignmentDetailList.forEach(
            (element) => {
              var TotalQty = 0;
              var TotalWeight = 0;

              if (
                element.Quantity != null &&
                element.Quantity != "" &&
                element.Quantity != undefined
              )
                TotalQty = element.Quantity;
              else TotalQty = 0;

              if (
                element.GrossWeight != null &&
                element.GrossWeight != "" &&
                element.GrossWeight != undefined
              )
                TotalWeight = element.GrossWeight;
              else TotalWeight = 0;

              PrintFormatsComponent.that.PrintGateInPass.TotalWeight +=
                TotalWeight;
              PrintFormatsComponent.that.PrintGateInPass.TotalQty += TotalQty;
            }
          );

          PrintFormatsComponent.that.PrintGateInPass.TotalWeight = parseFloat(
            PrintFormatsComponent.that.PrintGateInPass.TotalWeight.toFixed(2)
          );

          setTimeout(() => {
            var divElements = document.getElementById("PrintTripSheet");
            var $iframe: any = $("<iframe id='frame'>").appendTo("body");
            var printDiv = divElements.innerHTML;
            var win = $iframe[0].contentWindow || $iframe[0];
            $(win.document).ready(function () {
              setTimeout(() => {
                win.window.print();
                setTimeout(() => {
                  $iframe.remove();
                }, 500);
              });
            });
            $iframe.contents().find("body").html(printDiv);
            $("#PrintInvoice").val("");
            Helpers.setLoading(false);
          }, 1000);
        },
        (err) => {
          Helpers.setLoading(false);
          this.toastr.error("An error occured  !", "Error");
        }
      );
  }

  PrintLorryReceipt4(ConsignmentNoteId) {
    // if (this.hostUrl != 'https://ncc.ifreightbox.net/') {
    PrintFormatsComponent.that._appService
      .GetByTwoId("BookingOrigin", "GetPrintLR4", ConsignmentNoteId, this.From)
      .subscribe(
        (response) => {
          PrintFormatsComponent.that.ConsignmentsData = [];
          PrintFormatsComponent.that.ConsignmentsData.push(
            ...(response as any)
          );
          let i = 0;

          setTimeout(() => {
            PrintFormatsComponent.that.ConsignmentsData.forEach((element) => {
              if (
                element.GST == "Consignor" ||
                element.GST == "consignor" ||
                element.GST == "CONSIGNOR"
              ) {
                $(".Consigner_" + i).attr("checked", "true");
              }

              if (
                element.GST == "Consignee" ||
                element.GST == "consigee" ||
                element.GST == "CONSIGEE"
              ) {
                $(".Consignee_" + i).attr("checked", "true");
              }

              if (
                element.GST == "Transporter" ||
                element.GST == "transporter" ||
                element.GST == "TRANSPORTER"
              ) {
                $(".Transporter_" + i).attr("checked", "true");
              }

              var TotalQty = 0;
              var TotalWeight = 0;
              var TotalValue = 0;
              element.ProductDetail.forEach((element) => {
                TotalQty = TotalQty + element.Quantity;
                TotalWeight = TotalWeight + element.GrossWeight;
                TotalValue = TotalValue + element.Value;
              });

              element.TotalQty = TotalQty;
              element.TotalWeight = parseFloat(TotalWeight.toFixed(2));
              element.TotalValue = TotalValue;
              i++;
            });
          }, 200);

          if (this.InvoiceType == "PrintLorryReceipt4") {
            setTimeout(() => {
              var divElements = document.getElementById("PrintLorryReceipt4");
              var $iframe: any = $("<iframe id='frame'>").appendTo("body");
              var printDiv = divElements.innerHTML;
              var win = $iframe[0].contentWindow || $iframe[0];
              $(win.document).ready(function () {
                setTimeout(() => {
                  win.window.print();
                  setTimeout(() => {
                    $iframe.remove();
                  }, 500);
                });
              });
              $iframe.contents().find("body").html(printDiv);
              $("#PrintInvoice").val("");
              Helpers.setLoading(false);
            }, 1000);
          }
          if (this.InvoiceType == "PrintLorryReceipt5") {
            setTimeout(() => {
              var divElements = document.getElementById("PrintLorryReceipt5");
              var $iframe: any = $("<iframe id='frame'>").appendTo("body");
              var printDiv = divElements.innerHTML;
              var win = $iframe[0].contentWindow || $iframe[0];
              $(win.document).ready(function () {
                setTimeout(() => {
                  win.window.print();
                  setTimeout(() => {
                    $iframe.remove();
                  }, 500);
                });
              });
              $iframe.contents().find("body").html(printDiv);
              $("#PrintInvoice").val("");
              Helpers.setLoading(false);
            }, 1000);
          }
        },
        (err) => {
          Helpers.setLoading(false);
          this.toastr.error("An error occured  !", "Error");
        }
      );
    // } else {
    //   PrintFormatsComponent.that._appService.GetById("OrdersByVehicle", "GetPrintLR4Indent", ConsignmentNoteId).subscribe((response) => {
    //     PrintFormatsComponent.that.ConsignmentsData = [];
    //     PrintFormatsComponent.that.ConsignmentsData.push(...response as any);
    //     let i = 0;
    //     console.log('PrintFormatsComponent.that.ConsignmentsData', PrintFormatsComponent.that.ConsignmentsData);

    //     setTimeout(() => {
    //       PrintFormatsComponent.that.ConsignmentsData.forEach(
    //         (element) => {

    //           if (
    //             element.GST == "Consignor" ||
    //             element.GST == "consignor" ||
    //             element.GST == "CONSIGNOR"
    //           ) {
    //             $(".Consigner_" + i).attr("checked", 'true');
    //           }

    //           if (
    //             element.GST == "Consignee" ||
    //             element.GST == "consigee" ||
    //             element.GST == "CONSIGEE"
    //           ) {
    //             $(".Consignee_" + i).attr("checked", 'true');
    //           }

    //           if (
    //             element.GST == "Transporter" ||
    //             element.GST == "transporter" ||
    //             element.GST == "TRANSPORTER"
    //           ) {
    //             $(".Transporter_" + i).attr("checked", 'true');
    //           }

    //           var TotalQty = 0;
    //           var TotalWeight = 0;
    //           var TotalValue = 0;
    //           element.ProductDetail.forEach((element) => {
    //             TotalQty = TotalQty + element.Quantity;
    //             TotalWeight = TotalWeight + element.GrossWeight;
    //             TotalValue = TotalValue + element.Value;
    //           });

    //           element.TotalQty = TotalQty;
    //           element.TotalWeight = parseFloat(TotalWeight.toFixed(2));
    //           element.TotalValue = TotalValue;
    //           i++;
    //         }
    //       );
    //     }, 200);

    //     setTimeout(() => {
    //       var divElements = document.getElementById("PrintLRIndent");
    //       var $iframe: any = $("<iframe id='frame'>").appendTo("body");
    //       var printDiv = divElements.innerHTML;
    //       var win = $iframe[0].contentWindow || $iframe[0];
    //       $(win.document).ready(function () {
    //         setTimeout(() => {
    //           win.window.print();
    //           setTimeout(() => {
    //             $iframe.remove();
    //           }, 500);
    //         });
    //       });
    //       $iframe.contents().find("body").html(printDiv);
    //       $("#PrintInvoice").val("");
    //       Helpers.setLoading(false);
    //     }, 1000);
    //   },
    //     (err) => {
    //       Helpers.setLoading(false);
    //       this.toastr.error("An error occured  !", "Error");
    //     });
    // }
  }

  //added by vithujan 08-04-2023
  PrintNCCTermsCondition() {
    setTimeout(() => {
      var divElements = document.getElementById("ModalTermsCondition");
      var $iframe: any = $("<iframe id='frame'>").appendTo("body");
      var printDiv = divElements.innerHTML;
      var win = $iframe[0].contentWindow || $iframe[0];
      $(win.document).ready(function () {
        setTimeout(() => {
          win.window.print();
          setTimeout(() => {
            $iframe.remove();
          }, 500);
        });
      });
      $iframe.contents().find("body").html(printDiv);
      $("#PrintInvoice").val("");
      Helpers.setLoading(false);
    }, 1000);
  }

  //added by vithujan 05-05-2023
  TotalAmount: any = 0;
  TotalAdvance: any = 0;
  TotalBalance: any = 0;
  PrintQuote() {
    this.TotalAmount = 0;
    this.TotalAdvance = 0;
    this.TotalBalance = 0;

    let i = 0;
    this.InvoiceData = [];
    this.QuoteCompanyData = {};
    this.QuoteUserData = {};

    this._appService
      .GetById(
        "byVehicleIncome",
        "GetChargeListByIndentId",
        this.PrintQuoteData[0].Id
      )
      .subscribe(
        (res) => {
          res.forEach((element) => {
            this.InvoiceData.push(element);
            this.TotalAmount = this.TotalAmount + element.Amount;
            this.TotalAdvance = this.TotalAdvance + element.Advance;
            this.TotalBalance = this.TotalAmount - this.TotalAdvance;
          });

          this._appService
            .GetById("OrdersByVehicle", "GetCompanyForQuote", this.UserId)
            .subscribe(
              (res) => {
                this.QuoteCompanyData = res.Table[0];
                this.QuoteUserData = res.Table1[0];

                setTimeout(() => {
                  // kevin 13/03/2020
                  var divElements = document.getElementById("ModalPrintQuote");
                  // var $iframe = $("<iframe id='frame'>").appendTo("body");
                  var printDiv =
                    "<html><head><title> Lorry Receipt </title></head><body>" +
                    divElements.innerHTML +
                    "</body></html>";

                  var $iframe: any = $("<iframe id='frame'>").appendTo("body");
                  var printDiv = divElements.innerHTML;
                  var win = $iframe[0].contentWindow || $iframe[0];
                  $(win.document).ready(function () {
                    setTimeout(() => {
                      win.window.print();
                      setTimeout(() => {
                        $iframe.remove();
                      }, 100);
                    });
                  });
                  $iframe.contents().find("body").html(printDiv);
                }, 200);
              },
              (err) => {
                this.toastr.error("An error occured  !", "Error");
              }
            );
        },
        (err) => {
          this.toastr.error("An error occured  !", "Error");
        }
      );
  }
  //end

  PrintInvoiceInfinity() {
    this.totalAmountInvoiceDetails = 0;
    this.totalAmountCodDodArray = 0;

    for (var i = 0; i < this.PrintData.length; i++) {
      this.PrintData[i].InvoiceDetailsA = [];
      this.PrintData[i].InvoiceDetailsB = [];
      this.PrintData[i].Charges = [];
      this.codDodArray = [];

      this.PrintData[i].InvoiceDetails.forEach((element) => {
        if (element.ChargedGST == "NA") {
          this.PrintData[i].InvoiceDetailsB.push(element);
        } else {
          this.PrintData[i].InvoiceDetailsA.push(element);
        }

        var data = this.PrintData[i].Charges.filter(
          (x) => x.Name === element.ChargeCode
        );
        if (data.length <= 0) {
          var obj: any = {};
          obj.Name = element.ChargeCode;
          obj.Amount = 0;
          this.PrintData[i].Charges.push(obj);
        }

        this.totalAmountInvoiceDetails += element.Amount;
        if (element.IsCod_dod === 1) {
          this.codDodArray.push(element);
          this.totalAmountCodDodArray += element.Amount;
        }
      });

      this.sumInvoiceDetailsAmountAfterCod = this.PrintData[
        i
      ].InvoiceDetails.reduce((total, element) => total + element.Amount, 0);
      console.log(
        this.sumInvoiceDetailsAmountAfterCod,
        "Total sum of InvoiceDetails amounts after pushing into codDodArray"
      );

      this.PrintData[i].InvoiceDetails = this.PrintData[
        i
      ].InvoiceDetails.filter((element) => element.IsCod_dod !== 1);

      console.log(
        this.totalAmountInvoiceDetails,
        "Total amount of InvoiceDetails"
      );
      console.log(this.totalAmountCodDodArray, "Total amount of codDodArray");
      console.log(this.codDodArray, "codarray");
    }
    setTimeout(() => {
      var divElements = document.getElementById("PrintInvoiceInfinity");

      var $iframe: any = $("<iframe id='frame1'>").appendTo("body");

      var printDiv =
        "<style type='text/css' media='print'>@page { size: landscape; }</style><html><head><title></title></head><body>" +
        divElements.innerHTML +
        "</body></html>";

      var win = $iframe[0].contentWindow || $iframe[0];

      $(win.document).ready(function () {
        setTimeout(() => {
          win.window.print();

          setTimeout(() => {
            $iframe.remove();
          }, 500);
        });
      });

      $iframe.contents().find("body").html(printDiv);

      $("#PrintInvoice").val("");

      Helpers.setLoading(false);
    }, 1000);
  }
}
